/** @format */

export const DEFAULT_SORT_VALUE = '0';

export const GTGT_FILTER_NAME = 'Guaranteed_To_Get_There';
export const GTGT_TITLE = 'Shipping Options';
export const GTGT_FILTER_VALUE_DSG_PL = 'Get It By 12/24';
export const GTGT_FILTER_VALUE_GG = 'Get It By 12/24';

export const PRICE_FILTER_ID_DSG = 'dickssportinggoodsofferprice';
export const PRICE_FILTER_ID_GG = 'golfgalaxyofferprice';
export const PRICE_FILTER_ID_PL = 'publiclandsofferprice';
export const CATEGORY_FILTER_ID = 'facetCatgroup';
export const FACET_STORE = 'facetStore';
export const BRAND_FILTER_ID = 'X_BRAND';
export const RATINGS_FILTER_ID = 'X_BazaarVoice_ratings_DSG';
export const SIZE_FILTER_ID = '299';
export const KIDS_SHOES_SIZE = '5214';
export const WOMENS_SHOES_SIZE = '5213';
export const MENS_SHOES_SIZE = '5212';
export const DEFAULT_PAGE_SIZE = 48;
export const PAGE_SIZE_OPTIONS = [48, 96, 144];

export const FILTER_ID_5004 = '5004';
export const SALE_FILTER = 'Sale';
export const BOPIS_FILTER = 'BOPIS';

// Returns the brand-specific GTGT display value.
export function getGtgtDisplayValue(chainIdentifierAbbr: string): string {
  return chainIdentifierAbbr === 'gg' ? GTGT_FILTER_VALUE_GG : GTGT_FILTER_VALUE_DSG_PL;
}

// Returns true if the GTGT filter has at least one selectable option (value !== 'N').
export function hasGtgtSelectableOptions(valueList: { value: string }[]): boolean {
  return valueList?.some((item) => item.value !== 'N') ?? false;
}
